import React from 'react';

export function EyeIcon(props: React.SVGAttributes<{}>) {
    return (
        <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M10 1.16675C5.91712 1.16675 2.46019 3.61416 1.25 7.00008C2.46019 10.386 5.91712 12.8334 10 12.8334C14.0829 12.8334 17.5398 10.386 18.75 7.00008C17.5398 3.61416 14.0829 1.16675 10 1.16675Z"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0002 10.2408C11.8588 10.2408 13.3655 8.78983 13.3655 7.00002C13.3655 5.21021 11.8588 3.75928 10.0002 3.75928C8.1415 3.75928 6.63477 5.21021 6.63477 7.00002C6.63477 8.78983 8.1415 10.2408 10.0002 10.2408Z"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}